(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_mpsb-catalog-megamenu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mpsb-catalog-tabs')) {
    class MpsbCatalogTabs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.filters = Array.from(this.querySelectorAll('[data-catalog-filter]'));
        this.cards = Array.from(this.querySelectorAll('[data-catalog-card]'));
        this.heading = this.querySelector('[data-catalog-title]');
        this.viewAll = this.querySelector('[data-catalog-view-all]');
        this.empty = this.querySelector('[data-catalog-empty]');

        this.filters.forEach((filter, index) => {
          filter.addEventListener('click', () => this.activate(filter));
          filter.addEventListener('mouseenter', () => this.activate(filter));
          filter.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
      }

      activate(activeFilter) {
        const group = activeFilter.dataset.catalogFilter;
        let visibleCount = 0;

        this.filters.forEach((filter) => {
          const isActive = filter === activeFilter;
          filter.classList.toggle('is-active', isActive);
          filter.setAttribute('aria-pressed', String(isActive));
        });

        this.cards.forEach((card) => {
          const groups = (card.dataset.catalogGroups || '').split(' ');
          const isVisible = group === 'all' || groups.includes(group);
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        if (this.heading) this.heading.textContent = activeFilter.dataset.catalogHeading || activeFilter.textContent.trim();
        if (this.viewAll && activeFilter.dataset.catalogUrl) this.viewAll.href = activeFilter.dataset.catalogUrl;
        if (this.empty) this.empty.hidden = visibleCount > 0;
      }

      onKeydown(event, index) {
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = index;
        if (event.key === 'ArrowDown') nextIndex = (index + 1) % this.filters.length;
        if (event.key === 'ArrowUp') nextIndex = (index - 1 + this.filters.length) % this.filters.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.filters.length - 1;

        this.filters[nextIndex].focus();
        this.activate(this.filters[nextIndex]);
      }
    }

    customElements.define('mpsb-catalog-tabs', MpsbCatalogTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
